import React from 'react';
import PropTypes from 'prop-types';
import { StyledStatusPage, Content } from './StatusPageStyles';

const StatusPage = ({ icon, iconColor, accentColor, children }) => {
  return (
    <StyledStatusPage iconColor={iconColor} accentColor={accentColor}>
      <i className={icon} />
      <Content>{children}</Content>
    </StyledStatusPage>
  );
};

StatusPage.defaultProps = {
  iconColor: '#000',
};

StatusPage.propTypes = {
  icon: PropTypes.string.isRequired,
  iconColor: PropTypes.string,
  accentColor: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default StatusPage;
